import { render, staticRenderFns } from "./OrganizationSelectorVSelect.vue?vue&type=template&id=578af202&"
import script from "./OrganizationSelectorVSelect.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelectorVSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSelectorVSelect.vue?vue&type=style&index=0&id=578af202&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports